import { useEffect, useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { SocialMarquee } from "@/components/landing/SocialMarquee";
import { ProgramOverview } from "@/components/landing/ProgramOverview";
import { ProgramBreakdown } from "@/components/landing/ProgramBreakdown";
import { CalorieCalculator } from "@/components/landing/CalorieCalculator";
import { Testimonials } from "@/components/landing/Testimonials";
import { ProductSlider } from "@/components/landing/ProductSlider";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";
import { api } from "@/lib/api";

export default function Landing() {
  const [paypalEnabled, setPaypalEnabled] = useState(false);
  // Product flags drive the slider cards — active state and live spot counts.
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api
      .get("/config")
      .then((r) => {
        setPaypalEnabled(r.data.paypal_enabled);
        setProducts(r.data.products || []);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero />
      <SocialMarquee />
      <ProgramOverview />
      <ProgramBreakdown />
      <CalorieCalculator />
      <Testimonials />
      <ProductSlider paypalEnabled={paypalEnabled} products={products} />
      <ContactSection />
      <Footer />
    </div>
  );
}
